


export const frontendScenarios = [
  {
    _id: "1",
    title: "CPR Emergency",
    description: "Learn proper CPR techniques for cardiac arrest situations",
    points: 20,
    questions: [
      {
        _id: "1-1",
        question: "What is the first step when you find an unresponsive adult?",
        options: [
          "Start chest compressions immediately",
          "Check for responsiveness and breathing",
          "Call for help and get an AED",
          "Give two rescue breaths first"
        ],
        correctAnswer: "Check for responsiveness and breathing",
        explanation: "Always check for responsiveness and breathing first to assess the situation."
      },
      {
        _id: "1-2",
        question: "What is the correct compression-to-breath ratio for adult CPR?",
        options: [
          "15 compressions to 2 breaths",
          "30 compressions to 2 breaths",
          "30 compressions to 1 breath",
          "15 compressions to 1 breath"
        ],
        correctAnswer: "30 compressions to 2 breaths",
        explanation: "The current guideline is 30 chest compressions followed by 2 rescue breaths."
      },
      {
        _id: "1-3",
        question: "How deep should chest compressions be for an adult?",
        options: [
          "At least 1 inch",
          "At least 2 inches",
          "At least 3 inches",
          "At least 4 inches"
        ],
        correctAnswer: "At least 2 inches",
        explanation: "Chest compressions should be at least 2 inches deep for adults."
      },
      {
        _id: "1-4",
        question: "What is the recommended compression rate per minute?",
        options: [
          "60-80 compressions",
          "80-100 compressions",
          "100-120 compressions",
          "120-140 compressions"
        ],
        correctAnswer: "100-120 compressions",
        explanation: "The recommended compression rate is 100-120 compressions per minute."
      },
      {
        _id: "1-5",
        question: "When should you use an AED?",
        options: [
          "Only after 5 minutes of CPR",
          "As soon as it's available",
          "Only for children",
          "Only for drowning victims"
        ],
        correctAnswer: "As soon as it's available",
        explanation: "Use an AED as soon as it's available for the best chance of survival."
      },
      {
        _id: "1-6",
        question: "What should you do before using an AED?",
        options: [
          "Check for a pulse",
          "Make sure the person is dry",
          "Give two rescue breaths",
          "Perform CPR for 2 minutes"
        ],
        correctAnswer: "Make sure the person is dry",
        explanation: "Ensure the chest is dry before applying AED pads to prevent electrical arcing."
      },
      {
        _id: "1-7",
        question: "How should you position your hands for chest compressions?",
        options: [
          "One hand on the forehead, one on the chest",
          "Heel of one hand on the center of the chest, other hand on top",
          "Fingers interlocked over the sternum",
          "One hand on the lower part of the sternum"
        ],
        correctAnswer: "Heel of one hand on the center of the chest, other hand on top",
        explanation: "Place the heel of one hand on the center of the chest, place the other hand on top and interlock fingers."
      },
      {
        _id: "1-8",
        question: "When performing rescue breaths, how long should each breath last?",
        options: [
          "As quickly as possible",
          "About 1 second each",
          "About 3 seconds each",
          "About 5 seconds each"
        ],
        correctAnswer: "About 1 second each",
        explanation: "Each rescue breath should last about 1 second, making the chest visibly rise."
      },
      {
        _id: "1-9",
        question: "What should you do if you're untrained in CPR?",
        options: [
          "Perform hands-only CPR",
          "Wait for professional help",
          "Only perform rescue breaths",
          "Try to remember what you've seen on TV"
        ],
        correctAnswer: "Perform hands-only CPR",
        explanation: "Hands-only CPR (chest compressions only) is recommended for untrained rescuers."
      },
      {
        _id: "1-10",
        question: "When should you stop performing CPR?",
        options: [
          "After 5 minutes",
          "When you're too tired to continue",
          "When EMS personnel take over",
          "When the person starts breathing normally"
        ],
        correctAnswer: "When EMS personnel take over",
        explanation: "Continue CPR until EMS personnel arrive and take over, the person shows signs of life, or you're too exhausted to continue."
      }
    ]
  },
  {
    _id: "2",
    title: "Choking Emergency",
    description: "Learn how to assist choking victims of different ages",
    points: 20,
    questions: [
      {
        _id: "2-1",
        question: "What is the universal sign for choking?",
        options: [
          "Pointing to the mouth",
          "Clutching the throat with both hands",
          "Coughing violently",
          "Turning blue"
        ],
        correctAnswer: "Clutching the throat with both hands",
        explanation: "The universal sign for choking is clutching the throat with both hands."
      },
      {
        _id: "2-2",
        question: "What should you do first for a conscious choking adult?",
        options: [
          "Perform abdominal thrusts",
          "Give back blows",
          "Ask 'Are you choking?'",
          "Start CPR immediately"
        ],
        correctAnswer: "Ask 'Are you choking?'",
        explanation: "First ask 'Are you choking?' to confirm the person needs help."
      },
      {
        _id: "2-3",
        question: "Where should you position yourself for abdominal thrusts?",
        options: [
          "In front of the person",
          "Behind the person",
          "To the side of the person",
          "Kneeling in front of the person"
        ],
        correctAnswer: "Behind the person",
        explanation: "Stand behind the person with one foot forward between their feet for stability."
      },
      {
        _id: "2-4",
        question: "Where do you place your hands for abdominal thrusts?",
        options: [
          "On the chest",
          "On the upper abdomen above the navel",
          "On the lower abdomen below the navel",
          "On the back"
        ],
        correctAnswer: "On the upper abdomen above the navel",
        explanation: "Place the thumb side of your fist against the upper abdomen, above the navel but below the breastbone."
      },
      {
        _id: "2-5",
        question: "How should you perform abdominal thrusts?",
        options: [
          "Quick upward thrusts",
          "Slow downward pressure",
          "Side-to-side motions",
          "Circular motions"
        ],
        correctAnswer: "Quick upward thrusts",
        explanation: "Perform quick, inward and upward thrusts until the object is expelled or the person becomes unconscious."
      },
      {
        _id: "2-6",
        question: "What should you do if a choking person becomes unconscious?",
        options: [
          "Perform abdominal thrusts while they're lying down",
          "Start CPR beginning with chest compressions",
          "Roll them on their side and wait for help",
          "Perform finger sweeps to remove the object"
        ],
        correctAnswer: "Start CPR beginning with chest compressions",
        explanation: "If a choking person becomes unconscious, carefully lower them to the ground and begin CPR starting with chest compressions."
      },
      {
        _id: "2-7",
        question: "How many back blows should you give before abdominal thrusts?",
        options: [
          "3",
          "5",
          "7",
          "10"
        ],
        correctAnswer: "5",
        explanation: "Give 5 back blows between the shoulder blades with the heel of your hand before performing abdominal thrusts."
      },
      {
        _id: "2-8",
        question: "What modification should you make for choking in pregnant or obese individuals?",
        options: [
          "Perform abdominal thrusts higher on the chest",
          "Perform chest thrusts instead of abdominal thrusts",
          "Give only back blows",
          "Have them lie down to perform thrusts"
        ],
        correctAnswer: "Perform chest thrusts instead of abdominal thrusts",
        explanation: "For pregnant or obese individuals, perform chest thrusts instead of abdominal thrusts to avoid injury."
      },
      {
        _id: "2-9",
        question: "What should you do after the object is expelled?",
        options: [
          "Have them drink water immediately",
          "Encourage them to cough to clear remaining debris",
          "Check for injuries from the thrusts",
          "All of the above"
        ],
        correctAnswer: "All of the above",
        explanation: "After the object is expelled, have the person seen by a healthcare professional to check for injuries and complications."
      },
      {
        _id: "2-10",
        question: "When should you not perform abdominal thrusts?",
        options: [
          "On infants under 1 year",
          "On conscious choking adults",
          "On children over 1 year",
          "On unconscious choking victims"
        ],
        correctAnswer: "On infants under 1 year",
        explanation: "Abdominal thrusts are not recommended for infants under 1 year; use back blows and chest thrusts instead."
      }
    ]
  },
  {
    _id: "3",
    title: "Severe Burn Treatment",
    description: "Learn proper first aid for severe burns",
    points: 20,
    questions: [
      {
        _id: "3-1",
        question: "What is the first step in treating a severe burn?",
        options: [
          "Apply butter or oil",
          "Cool the burn with running water",
          "Remove clothing stuck to the burn",
          "Apply antibiotic ointment"
        ],
        correctAnswer: "Cool the burn with running water",
        explanation: "Cool the burn with cool (not cold) running water for at least 10-20 minutes to reduce pain and swelling."
      },
      {
        _id: "3-2",
        question: "How long should you cool a severe burn with water?",
        options: [
          "1-2 minutes",
          "5-10 minutes",
          "10-20 minutes",
          "Until the pain stops completely"
        ],
        correctAnswer: "10-20 minutes",
        explanation: "Cool the burn with cool running water for 10-20 minutes to reduce pain and swelling."
      },
      {
        _id: "3-3",
        question: "What should you never do to a severe burn?",
        options: [
          "Cover it with a sterile dressing",
          "Pop blisters",
          "Elevate the burned area",
          "Give pain medication if appropriate"
        ],
        correctAnswer: "Pop blisters",
        explanation: "Never pop burn blisters as they protect against infection."
      },
      {
        _id: "3-4",
        question: "What type of burn requires immediate medical attention?",
        options: [
          "First-degree burns",
          "Second-degree burns larger than 3 inches",
          "All burns",
          "Only third-degree burns"
        ],
        correctAnswer: "Second-degree burns larger than 3 inches",
        explanation: "Second-degree burns larger than 3 inches require medical attention, as do all third-degree burns."
      },
      {
        _id: "3-5",
        question: "How should you cover a severe burn after cooling?",
        options: [
          "With a tight bandage",
          "With a clean, non-stick dressing",
          "With cotton wool",
          "Leave it uncovered"
        ],
        correctAnswer: "With a clean, non-stick dressing",
        explanation: "Cover the burn with a clean, non-stick dressing to protect it from infection."
      },
      {
        _id: "3-6",
        question: "What should you do if clothing is stuck to a burn?",
        options: [
          "Pull it off quickly",
          "Cut around it, leaving the stuck part",
          "Soak it with water until it comes loose",
          "Apply oil to help release it"
        ],
        correctAnswer: "Cut around it, leaving the stuck part",
        explanation: "Never remove clothing stuck to a burn; cut around it and leave the stuck portion in place."
      },
      {
        _id: "3-7",
        question: "What is a sign of a third-degree burn?",
        options: [
          "Redness and pain",
          "Blisters and swelling",
          "Charred black or white leathery appearance",
          "All of the above"
        ],
        correctAnswer: "Charred black or white leathery appearance",
        explanation: "Third-degree burns may appear charred black or white and leathery, and often have little pain due to nerve damage."
      },
      {
        _id: "3-8",
        question: "What should you do for a chemical burn?",
        options: [
          "Apply neutralizing chemicals",
          "Brush off dry chemicals before flushing with water",
          "Immediately flush with large amounts of water",
          "Both 2 and 3"
        ],
        correctAnswer: "Both 2 and 3",
        explanation: "For chemical burns, brush off dry chemicals first, then flush with copious amounts of water for at least 20 minutes."
      },
      {
        _id: "3-9",
        question: "When should you not use water to cool a burn?",
        options: [
          "For electrical burns",
          "For chemical burns",
          "For large burns covering more than 10% of body",
          "For all severe burns"
        ],
        correctAnswer: "For large burns covering more than 10% of body",
        explanation: "For very large burns, avoid cooling with water to prevent hypothermia."
      },
      {
        _id: "3-10",
        question: "What is the rule of nines used for in burn treatment?",
        options: [
          "Determining the depth of a burn",
          "Estimating the percentage of body surface burned",
          "Calculating fluid replacement needs",
          "Both 2 and 3"
        ],
        correctAnswer: "Both 2 and 3",
        explanation: "The rule of nines helps estimate the percentage of body surface area burned to guide fluid resuscitation and treatment decisions."
      }
    ]
  },
  {
    _id: "4",
    title: "Sudden Cardiac Arrest",
    description: "Learn to recognize and respond to cardiac emergencies",
    points: 20,
    questions: [
      {
        _id: "4-1",
        question: "What is the most common sign of sudden cardiac arrest?",
        options: [
          "Chest pain",
          "Sudden collapse and loss of consciousness",
          "Difficulty breathing",
          "Seizure-like activity"
        ],
        correctAnswer: "Sudden collapse and loss of consciousness",
        explanation: "Sudden cardiac arrest typically presents with immediate collapse and loss of consciousness."
      },
      {
        _id: "4-2",
        question: "What is the first thing you should do when encountering someone who may be in cardiac arrest?",
        options: [
          "Start chest compressions",
          "Check for responsiveness and breathing",
          "Call for help and get an AED",
          "Check for a pulse"
        ],
        correctAnswer: "Check for responsiveness and breathing",
        explanation: "First check if the person is responsive and breathing normally."
      },
      {
        _id: "4-3",
        question: "How soon should CPR be started after cardiac arrest?",
        options: [
          "Within 1 minute",
          "Within 3 minutes",
          "Within 5 minutes",
          "Within 10 minutes"
        ],
        correctAnswer: "Within 1 minute",
        explanation: "CPR should be started as soon as possible, ideally within the first minute after cardiac arrest."
      },
      {
        _id: "4-4",
        question: "What is the most critical component of CPR for cardiac arrest?",
        options: [
          "Rescue breaths",
          "Head tilt-chin lift",
          "High-quality chest compressions",
          "Rapid transport to hospital"
        ],
        correctAnswer: "High-quality chest compressions",
        explanation: "High-quality chest compressions with minimal interruptions are the most critical component of CPR."
      },
      {
        _id: "4-5",
        question: "What does an AED do?",
        options: [
          "Restarts the heart",
          "Analyses heart rhythm and delivers shock if needed",
          "Provides continuous monitoring of heart function",
          "Administers medication automatically"
        ],
        correctAnswer: "Analyses heart rhythm and delivers shock if needed",
        explanation: "An AED analyzes the heart rhythm and delivers a shock if it detects a shockable rhythm."
      },
      {
        _id: "4-6",
        question: "When using an AED, what should you do before delivering a shock?",
        options: [
          "Ensure no one is touching the person",
          "Remove medication patches from the chest",
          "Dry the chest if wet",
          "All of the above"
        ],
        correctAnswer: "All of the above",
        explanation: "Before delivering a shock, ensure no one is touching the person, remove any medication patches, and dry the chest if wet."
      },
      {
        _id: "4-7",
        question: "What is the survival chain for cardiac arrest?",
        options: [
          "Early recognition, early CPR, early defibrillation, advanced care",
          "Call 911, start CPR, use AED, transport to hospital",
          "Check response, give oxygen, start IV, administer drugs",
          "Airway, breathing, circulation, defibrillation"
        ],
        correctAnswer: "Early recognition, early CPR, early defibrillation, advanced care",
        explanation: "The survival chain includes early recognition, early CPR, early defibrillation, and advanced care."
      },
      {
        _id: "4-8",
        question: "What is the most common shockable rhythm in cardiac arrest?",
        options: [
          "Asystole",
          "Pulseless electrical activity (PEA)",
          "Ventricular fibrillation (VF)",
          "Bradycardia"
        ],
        correctAnswer: "Ventricular fibrillation (VF)",
        explanation: "Ventricular fibrillation is the most common shockable rhythm in sudden cardiac arrest."
      },
      {
        _id: "4-9",
        question: "How often should rescuers switch roles during CPR?",
        options: [
          "Every minute",
          "Every 2 minutes",
          "Every 5 minutes",
          "When a rescuer becomes fatigued"
        ],
        correctAnswer: "Every 2 minutes",
        explanation: "Rescuers should switch roles every 2 minutes to prevent fatigue and maintain compression quality."
      },
      {
        _id: "4-10",
        question: "What should you do after the AED delivers a shock?",
        options: [
          "Immediately check for a pulse",
          "Resume CPR starting with chest compressions",
          "Wait to see if the person revives",
          "Give two rescue breaths first"
        ],
        correctAnswer: "Resume CPR starting with chest compressions",
        explanation: "After the AED delivers a shock, immediately resume CPR starting with chest compressions."
      }
    ]
  },
  {
    _id: "5",
    title: "Stroke Emergency",
    description: "Learn to recognize and respond to stroke emergencies",
    points: 20,
    questions: [
      {
        _id: "5-1",
        question: "What does the acronym FAST stand for in stroke recognition?",
        options: [
          "Face, Arms, Speech, Time",
          "Fast Action Saves Time",
          "Fever, Alertness, Strength, Talking",
          "First Aid Stroke Treatment"
        ],
        correctAnswer: "Face, Arms, Speech, Time",
        explanation: "FAST stands for Face drooping, Arm weakness, Speech difficulty, Time to call emergency services."
      },
      {
        _id: "5-2",
        question: "What is the first thing you should do if you suspect someone is having a stroke?",
        options: [
          "Give them aspirin",
          "Call emergency services immediately",
          "Have them lie down and elevate their feet",
          "Check their blood pressure"
        ],
        correctAnswer: "Call emergency services immediately",
        explanation: "Time is critical in stroke treatment; call emergency services immediately."
      },
      {
        _id: "5-3",
        question: "What should you do while waiting for emergency services for a stroke victim?",
        options: [
          "Give them food or drink",
          "Keep them calm and comfortable",
          "Administer medication for high blood pressure",
          "Have them exercise to improve circulation"
        ],
        correctAnswer: "Keep them calm and comfortable",
        explanation: "Keep the person calm and comfortable while waiting for emergency services."
      },
      {
        _id: "5-4",
        question: "What is the time window for effective treatment of ischemic stroke with clot-busting drugs?",
        options: [
          "1 hour",
          "3 hours",
          "4.5 hours",
          "6 hours"
        ],
        correctAnswer: "4.5 hours",
        explanation: "The typical time window for thrombolytic therapy is within 4.5 hours of symptom onset."
      },
      {
        _id: "5-5",
        question: "Which side of the body would be affected by a stroke in the right side of the brain?",
        options: [
          "Right side",
          "Left side",
          "Both sides",
          "Neither side"
        ],
        correctAnswer: "Left side",
        explanation: "A stroke on one side of the brain affects the opposite side of the body."
      },
      {
        _id: "5-6",
        question: "What should you note about when the stroke symptoms began?",
        options: [
          "To help doctors determine appropriate treatment",
          "For insurance purposes",
          "To tell family members",
          "All of the above"
        ],
        correctAnswer: "To help doctors determine appropriate treatment",
        explanation: "Knowing when symptoms began helps medical professionals determine appropriate treatment options."
      },
      {
        _id: "5-7",
        question: "What is a TIA?",
        options: [
          "A type of severe stroke",
          "A transient ischemic attack or 'mini-stroke'",
          "A medication for stroke",
          "A diagnostic test for stroke"
        ],
        correctAnswer: "A transient ischemic attack or 'mini-stroke'",
        explanation: "A TIA is a transient ischemic attack, often called a 'mini-stroke', with temporary symptoms."
      },
      {
        _id: "5-8",
        question: "What should you not do for someone having a stroke?",
        options: [
          "Give them anything to eat or drink",
          "Talk to them reassuringly",
          "Loosen tight clothing",
          "Note the time symptoms started"
        ],
        correctAnswer: "Give them anything to eat or drink",
        explanation: "Never give food or drink to someone having a stroke as swallowing may be impaired."
      },
      {
        _id: "5-9",
        question: "What additional symptoms might indicate a stroke besides FAST?",
        options: [
          "Sudden severe headache",
          "Sudden trouble seeing in one or both eyes",
          "Sudden dizziness or loss of balance",
          "All of the above"
        ],
        correctAnswer: "All of the above",
        explanation: "Other stroke symptoms include sudden severe headache, vision problems, and dizziness or balance issues."
      },
      {
        _id: "5-10",
        question: "Why is it important to have the person transported by ambulance for a stroke?",
        options: [
          "Ambulances can get through traffic faster",
          "Paramedics can begin treatment and alert the hospital",
          "It's required by insurance",
          "Family members shouldn't drive in an emergency"
        ],
        correctAnswer: "Paramedics can begin treatment and alert the hospital",
        explanation: "Paramedics can provide initial care and alert the hospital, allowing the stroke team to prepare for immediate treatment."
      }
    ]
  },
  {
    _id: "6",
    title: "Pediatric Choking for Infants",
    description: "Learn how to assist choking infants under 1 year",
    points: 20,
    questions: [
      {
        _id: "6-1",
        question: "What is the first step for a choking infant who is conscious?",
        options: [
          "Perform abdominal thrusts",
          "Give back blows and chest thrusts",
          "Perform finger sweeps",
          "Turn infant upside down and shake gently"
        ],
        correctAnswer: "Give back blows and chest thrusts",
        explanation: "For conscious choking infants, give back blows followed by chest thrusts (not abdominal thrusts)."
      },
      {
        _id: "6-2",
        question: "How should you position an infant for back blows?",
        options: [
          "Lying on their back on a firm surface",
          "Sitting upright supported by your hand",
          "Face down along your forearm with head lower than chest",
          "Over your shoulder like when burping"
        ],
        correctAnswer: "Face down along your forearm with head lower than chest",
        explanation: "Position the infant face down along your forearm, supporting the head and jaw, with head lower than chest."
      },
      {
        _id: "6-3",
        question: "How many back blows should you give?",
        options: [
          "3",
          "5",
          "7",
          "10"
        ],
        correctAnswer: "5",
        explanation: "Give 5 back blows between the shoulder blades with the heel of your hand."
      },
      {
        _id: "6-4",
        question: "How should you position an infant for chest thrusts?",
        options: [
          "Face up along your forearm with head lower than chest",
          "Sitting upright on your lap",
          "Lying on their back on a firm surface",
          "Over your knee face down"
        ],
        correctAnswer: "Face up along your forearm with head lower than chest",
        explanation: "After back blows, turn the infant face up along your forearm, still with head lower than chest."
      },
      {
        _id: "6-5",
        question: "Where should you position your hands for chest thrusts on an infant?",
        options: [
          "On the upper abdomen",
          "On the middle of the breastbone",
          "On the lower half of the breastbone",
          "On the chest between the nipples"
        ],
        correctAnswer: "On the lower half of the breastbone",
        explanation: "Place two fingers on the lower half of the breastbone, about one finger's width below the nipple line."
      },
      {
        _id: "6-6",
        question: "How deep should chest thrusts be on an infant?",
        options: [
          "½ inch",
          "1 inch",
          "1.5 inches",
          "2 inches"
        ],
        correctAnswer: "1.5 inches",
        explanation: "Chest thrusts should be about 1.5 inches deep, or about one-third the depth of the chest."
      },
      {
        _id: "6-7",
        question: "What should you do if an infant becomes unconscious during choking?",
        options: [
          "Continue back blows and chest thrusts",
          "Start CPR beginning with chest compressions",
          "Perform finger sweeps to remove the object",
          "All of the above"
        ],
        correctAnswer: "Start CPR beginning with chest compressions",
        explanation: "If an infant becomes unconscious, carefully lower them to a firm surface and begin CPR starting with chest compressions."
      },
      {
        _id: "6-8",
        question: "When should you perform finger sweeps in an infant's mouth?",
        options: [
          "After each set of back blows",
          "Only if you can see the object",
          "Never perform blind finger sweeps",
          "When the infant becomes unconscious"
        ],
        correctAnswer: "Only if you can see the object",
        explanation: "Only perform finger sweeps if you can see the object; blind sweeps may push it further down."
      },
      {
        _id: "6-9",
        question: "How should you modify techniques for a very small or newborn infant?",
        options: [
          "Use less force for back blows and chest thrusts",
          "Use only one finger for chest thrusts",
          "Hold the infant in a different position",
          "No modification needed - use standard technique"
        ],
        correctAnswer: "Use less force for back blows and chest thrusts",
        explanation: "For very small or newborn infants, use less force during back blows and chest thrusts."
      },
      {
        _id: "6-10",
        question: "What is the correct compression-to-breath ratio for infant CPR?",
        options: [
          "15 compressions to 2 breaths",
          "30 compressions to 2 breaths",
          "30 compressions to 1 breath",
          "15 compressions to 1 breath"
        ],
        correctAnswer: "30 compressions to 2 breaths",
        explanation: "The compression-to-breath ratio for infant CPR is 30:2 for a single rescuer."
      }
    ]
  }
];